<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <div class="w-100">
            <div class="row">
              <div class="col-lg-12">
                <h1 class="subheader-title mb-lg-0">
                  <i class="subheader-icon fal fa-cog"></i> Настройки
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-container show">
          <div class="panel-container show" v-if="loading">
            <div class="panel-content p-6 m-6">
              <content-placeholders :centered="true">
                <content-placeholders-text :lines="4" />
              </content-placeholders>
            </div>
          </div>
          <div class="panel-content" v-if="!loading">
            <div class="row">
              <div class="col-12">
                  <div class="panel-tag mb-4" v-if="'password' in notification">{{ notification['password'] }}</div>
                  <div class="form-group row">
                    <label class="col-xl-12 form-label">Персональные данные</label>
                    <div class="col-6 pr-1">
                      <input type="text" data-input="firstname" class="form-control" @change="updateUser('firstname')" v-bind:class="{ 'is-invalid': 'firstname' in errors, 'ok': 'firstname' in notification}" v-on:focus="$delete(errors, 'firstname'); $delete(notification, 'firstname')" placeholder="Имя" v-model="user.firstname" required/>
                      <div class="invalid-feedback" v-if="'firstname' in errors">{{ errors['firstname'] }}</div>
                    </div>
                    <div class="col-6 pl-1">
                      <input type="text" data-input="lastname" class="form-control" @change="updateUser('lastname')" v-bind:class="{ 'is-invalid': 'lastname' in errors, 'ok': 'lastname' in notification}" v-on:focus="$delete(errors, 'lastname'); $delete(notification, 'lastname')" placeholder="Фамилия" v-model="user.lastname" required/>
                      <div class="invalid-feedback" v-if="'lastname' in errors">{{ errors['lastname'] }}</div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label class="form-label">Контактная информация</label>
                    <input type="email" data-input="mail" class="form-control" v-mask="'email'" @change="updateUser('mail')" v-bind:class="{ 'is-invalid': 'mail' in errors, 'ok': 'mail' in notification}" v-on:focus="$delete(errors, 'mail'); $delete(notification, 'mail')" placeholder="Почтовый ящик" v-model="user.mail" required/>
                    <div class="invalid-feedback" v-if="'mail' in errors">{{ errors['mail'] }}</div>
                  </div>

                  <hr />

                  <div class="form-group row">
                    <label class="col-xl-12 form-label" for="fname">Почтовые уведомления</label>
                    <div class="col-8 pr-1">
                      Новости и акции
                      <br />
                      <span class="help-block">На регистрационный почтовый ящик мы будем отправлять Вам информацию о новостях и проходящих акциях</span>
                    </div>
                    <div class="col-4 text-right">
                      <toggle-button data-input="subscribe" @change="updateUser('subscribe')" :margin="3" :color="{checked: '#82C7EB', unchecked: '#BFCBD9'}" v-model="user.subscribe" :labels="{checked: 'Подписан', unchecked: 'Отписан'}" :font-size="14" :height="36" :width="120"/>
                    </div>
                  </div>

                  <hr />

                  <form @submit.prevent="changePassword">

                    <div class="form-group row">
                      <label class="col-xl-12 form-label" for="fname">Безопасность</label>
                      <div class="col-6 pr-1">
                        <input type="password" data-input="password" class="form-control" v-bind:class="{ 'is-invalid': 'password' in errors}" v-on:focus="$delete(errors, 'password')" placeholder="Новый пароль" v-model="password" required/>
                        <div class="invalid-feedback" v-if="'password' in errors">{{ errors['password'] }}</div>
                      </div>
                      <div class="col-6 pl-1">
                        <input type="password" data-input="password_confirmation" class="form-control" placeholder="Повторите пароль" v-model="password_confirmation" required/>
                      </div>
                    </div>

                    <div class="row no-gutters">
                      <div class="col-md-12 ml-auto">
                        <button id="js-login-btn" data-button="password" type="submit" class="btn btn-sm btn-outline-success">Изменить пароль</button>
                      </div>
                    </div>

                  </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Настройки',
    },
    data() {
      return {
        // Статус загрузки
        loading: true,
        // Данные пользователя
        user: {},
        // Ошибки
        errors: {},
        // Уведомления
        notification: {},
        // Изменение пароля
        password: '',
        password_confirmation: ''
      };
    },
    methods: {
      // Получение данных пользователя
      getUser () 
      {
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/users').then(response =>
        {
          this.user = response.data.data;
          this.loading = false;
        });
      },
      // Изменение пользователя
      updateUser (element) 
      {
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/users/edit', {...this.user}).then(response =>
        {
          if(element !== undefined)
          {
            // Показ и скрытие уведомления
            this.$set(this.notification, element, '');
            setTimeout(function(){ this.$delete(this.notification, element) }.bind(this, element), 5000);
          }
        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      },
      // Изменение пароля
      changePassword () 
      {
        this.$axios.post(process.env.VUE_APP_API_URL+'/v1/users/password', {password: this.password, password_confirmation: this.password_confirmation}).then(response =>
        {
          // Показ и скрытие уведомления
          this.$set(this.notification, 'password', 'Изменения сохранены');
          setTimeout(function(){ this.$delete(this.notification, 'password') }.bind(this), 5000);

          // Очистка данных
          this.password = '';
          this.password_confirmation = '';
          this.errors = {};

          // Обновление токена
          localStorage.token = response.data.token;

          // Поднятие страницы наверх
          window.scrollTo(0, 0);

        }).catch(error => {
          // Собираем ошибки
          this.errors = {};
          $.each(error.response.data.errors, function(index, value) 
          {
            this.$set(this.errors, index, value[0])
          }.bind(this));
        });
      },
    },
    // Подгрузка данных
    mounted () 
    {
      this.getUser();
    },
  }
</script>

<style>
  .v-switch-core {
    border-radius: 4px !important;
  }
  .v-switch-button {
    border-radius: 4px !important;
  }
  .v-switch-label {
    line-height: 38px !important;
  }
  .v-switch-label.v-right {
    padding-right: 7.5px;
  }
  .v-switch-label.v-left {
    padding-left: 2px;
  }
</style>